module.exports = __webpack_public_path__ + "img/savings.0e9f7e49.svg";